module.exports = __webpack_public_path__ + "img/goin3.c5d5e4e5.png";